import React  from "react";

const ViewLeaveCredits = () => {
    
	return (
	    <div>
	    </div>
    );
};

export default ViewLeaveCredits;